import { useState, useEffect } from "react";
import { fieldType } from "../../../../types/form";
import { cva } from "class-variance-authority";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { TooltipItem } from "src/utils/Tooltip";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    errors?: any;
    value: string;
};

function Grade(props: Props) {
    const { dataField, value, onChange, errors } = props;

    const paginationButtonStyle = cva(
        "border border-[#DFE4EA] rounded-md w-9 h-9 items-center justify-center flex flex-col cursor-pointer",
        {
            variants: {
                active: {
                    true: "bg-darkblue text-white",
                    false: "",
                },
            },
            defaultVariants: {
                active: false,
            },
        }
    );

    return (
        <div className={`${dataField.width} mb-5`}>
            <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                <span className="flex flex-row items-center">{dataField.title} {dataField.noticeIcon && <TooltipItem wrapperClassName="flex w-[758px]" position="top-right" tooltipsComponent={dataField.notice} tooltipsText="">
                    <>&nbsp;&nbsp;<InfoIcon /></>
                </TooltipItem>}</span>
                {dataField.require && (
                    <div className="flex flex-row justify-between">
                        {Object.keys(errors).length > 0 && errors[dataField.key] && (
                            <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                        )}
                        <span className="text-[#BA0C2F]">*</span>
                    </div>
                )}
            </label>
            <FlexCol className="mt-2">
                <FlexRow className="gap-x-2">
                    <div
                        onClick={() => onChange('1')}
                        className={twMerge(paginationButtonStyle({ active: Number(value) === 1 }))}
                    >1</div>
                    <div
                        onClick={() => onChange('2')}
                        className={twMerge(paginationButtonStyle({ active: Number(value) === 2 }))}
                    >2</div>
                    <div
                        onClick={() => onChange('3')}
                        className={twMerge(paginationButtonStyle({ active: Number(value) === 3 }))}
                    >3</div>
                    <div
                        onClick={() => onChange('4')}
                        className={twMerge(paginationButtonStyle({ active: Number(value) === 4 }))}
                    >4</div>
                    <div
                        onClick={() => onChange('5')}
                        className={twMerge(paginationButtonStyle({ active: Number(value) === 5 }))}
                    >5</div>
                </FlexRow>
            </FlexCol>
        </div>
    );
}

export default Grade;
